export enum ShareLinkPanel {
  WHATSAPP = 'WHATSAPP',
  COPY_LINK = 'COPY_LINK',
  EMAIL = 'EMAIL',
}
